import { Box, Stack, Text, styled } from '@ltvco/refresh-lib/theme';

export const ResultsContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.spacing(2.5),
}));

export const RecallReportMetricRow = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: '1px solid',
  borderColor: theme.palette.divider,
  paddingBottom: theme.spacing(1),
  flex: 1,
  minWidth: 0,
}));

export const RecallReportMetricLabelGroup = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(0.5),
}));

export const RecallReportMetricValue = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
  textAlign: 'right',
  paddingLeft: theme.spacing(1),
}));

export const RecallDetailImageWrapper = styled(Stack)(({ theme }) => ({
  maxWidth: 200,
  borderRadius: theme.spacing(2.5),
  overflow: 'hidden',
  border: `1px solid ${theme.palette.divider}`,
}));

export const RecallDetailImage = styled('img')(() => ({
  display: 'block',
  width: '100%',
  height: 'auto',
  objectFit: 'cover',
}));
